import axiosInstance from './axiosInstance';

import type { Response } from './axiosInstance';

export const compileLaTeX = async (filePath: string): Promise<Response<string> | undefined> => {
    try {
        const response = await axiosInstance.get<Response<string>>('/latex/compile/async', {
            headers: {
                'Content-Type': 'application/json'
            },
            params:{
                path: filePath
            }
        });
        return response?.data;
    } catch (e) {
        console.error('Failed to compile LaTeX', e);
        return undefined;
    }
}